module.exports = __webpack_public_path__ + "img/behold-10.20f6b0ec.png";